import R14, { AsyncStorage, AsyncSessionStorage } from "../core";
import RSAencryption from "../utils/RSAencryption";
import CommonUtility from "../utils/CommonUtility";
import { LOGIN_TYPE } from "../constant/app.data.constant";
import { CommonString } from "../constant/appCommonText";
export default class UserSessionDomain extends R14.Domain {
  constructor(props) {
    super(props);
    this._metadata = {
      accessToken: null,
      refreshToken: null,
      userDetails: null,
    };
    this.state = {
      userDetail: {},
      initialized: false,
      loggedIn: false,
      leftMenuToggle: true, //true //false,
      leftMenuOverlay: false,
      facebookMediaLoginPID: false,
      googleMediaLoginPID: false,
      pchRegistrationTypeProvider: false,
      pchRegistrationTypePatient: false,
      subRoleUpdate: false,
      isProfileDetailsOpen: false,
      isLoggedOut: false,
      isTooltipOpen: false,
      isUberDocs: false, //false //true
      linkedPayers: [],
      userRoles: "",
      isExternalLogin: false,
      userOrgs: [],
      defaultOrg: null,
      userBUDetails: [],
      pnToken: "",
      isLoading: false,
      isAlreadySessionActive: false
    };
  }

  async domainDidLoad() {
    return await this.init();
  }

  async init() {
    if (this.state.initialized) return true;
    let access_token =
      (await AsyncSessionStorage.getItem(CommonString.LOCAL_STORAGE_ACCESSTOKEN)) || null;
    let refresh_token =
      (await AsyncSessionStorage.getItem(CommonString.LOCAL_STORAGE_REFRESHTOKEN)) || null;
    let userDetails = await this.dm.rest.getUser();
    let userRoles = await AsyncStorage.getItem("userRoles") || "";
    this.setState({
      initialized: true,
      access_token,
      refresh_token,
      userDetails,
      userRoles,
    });
    this.setLoggedIn(access_token ? true : false);
    return true;
  }

  async loginAuth(
    loginInput,
    fields = "uid pid payerId lastLoginDate changePasswordNow googleProfileID amazonProfileID appleProfileID userType firstName lastName email mobileNumber subRole {appName appRole} isActive currencyFormat{label value}"
  ) {
    await CommonUtility.htmlDecode(loginInput);

    let encryptUsername = RSAencryption.EnctyptString(loginInput.username);
    let encryptPassword = !!loginInput.password
      ? loginInput.bEncryptRequired === undefined || loginInput.bEncryptRequired === true
        ? (!!await CommonUtility.getWithExpiry(loginInput.signInLocation === "XBP" ? "XBPUsername" : "username") ? loginInput.password : RSAencryption.EnctyptString(loginInput.password))
        : loginInput.password
      : "";
    let data = {
      username: encryptUsername,
      password: encryptPassword,
      socialProfileId: loginInput.socialProfileId,
      loginType: !!loginInput.loginType ? loginInput.loginType : LOGIN_TYPE.NORMAL,
      signInLocation: loginInput.signInLocation,
    };

    let res = await this.api.mutate(
      `mutation Authenticate($input: EncryptedAuthUserInput!) {
        authenticate(input: $input){
          isAlreadySessionActive access_token refresh_token error success message 
          error linkedPayers { isPrimaryPID pid buId billerId }
          userBUDetails { uid firstName lastName userDetailUid payerRef buId buName billerId billerRef billerName country addressLine1 addressLine2 state town postCode countryObject{label value} stateObject{label value} cityObject{label value} }
          userLoginDetail {
             ${fields}
            }
        }
    }`,
      {
        input: data,
      }
    );
    // if (res.data === null)// throw new Error("Auth failed due to invalid credentials/absolute PID")
    if (res.data.authenticate.error || res.data.authenticate.success === false) throw res.data.authenticate;
    const isLoggedIn = await this._processAuthResult(res.data.authenticate, loginInput.signInLocation);
    return {
      isLoggedIn,
      isAlreadySessionActive: res.data?.authenticate?.isAlreadySessionActive
    }
  }

  async _processAuthResult(res, signInLocation, loginType) {
    if (!res.access_token || !res.refresh_token) throw new Error("Unknown Auth Error: No Access.");
    const { access_token, refresh_token, userLoginDetail, linkedPayers, userBUDetails } = res;
    await AsyncSessionStorage.setItem(CommonString.LOCAL_STORAGE_ACCESSTOKEN, access_token);
    await AsyncStorage.setItem(CommonString.LOCAL_STORAGE_ACCESSTOKEN, access_token);
    await AsyncSessionStorage.setItem(CommonString.LOCAL_STORAGE_REFRESHTOKEN, refresh_token);
    this.setState({ access_token, refresh_token });
    //Enforcing to generate new tokens.
    this.setLoggedIn(this.getAccessToken());
    userLoginDetail.userType = "XBP";

    let filteredUserBUDetails = userBUDetails || [];

    await this.updateSMBOrganization(userLoginDetail);
    await AsyncStorage.setItem(CommonString.LOCAL_STORAGE_LINKPAYER, RSAencryption.EnctyptString(JSON.stringify(linkedPayers || [])));
    await AsyncStorage.setItem(CommonString.LOCAL_STORAGE_BUDETAILS, RSAencryption.EnctyptString(JSON.stringify(filteredUserBUDetails || [])));
    await AsyncStorage.setItem("loginType", !!loginType ? loginType : signInLocation);
    this.setState({
      linkedPayers: linkedPayers || [],
      userBUDetails: filteredUserBUDetails,
      isUberDocs: loginType === LOGIN_TYPE.UBERDOC ? true : false,
      leftMenuToggle: loginType === LOGIN_TYPE.UBERDOC ? false : true,
      isExternalLogin: (loginType === LOGIN_TYPE.UBERDOC || loginType === LOGIN_TYPE.PCHGLOBAL) ? true : false
    });
     if(!res.isAlreadySessionActive) this.dm.user.getBillerListFromPam();
    return this.isLoggedIn;

  }

  async updateSMBOrganization(userLoginDetail, defaultOrg = null) {
    userLoginDetail.defaultOrg = defaultOrg;
    this.setState({
        userLoginDetail: userLoginDetail
      });
    await AsyncStorage.setItem(CommonString.LOCAL_STORAGE_PROFILE, RSAencryption.EnctyptString(JSON.stringify(userLoginDetail)));
  }

  async logout(isTerminateOtherSessions = false) {
    try {
      if(isTerminateOtherSessions === true){
        await this.api.mutate(
          `mutation Logout($input:  KCRequestPayload!) {
          logout(input: $input)
        }`,
        {
          input: { isLogOutOtherDevice: true }
        });
        return true;
      };

      await this.api.mutate(
        `mutation Logout($input:  KCRequestPayload!) {
        logout(input: $input)
      }`,
      {
        input: { }
      });
      await this.dm.dashboard.resetDashboardDomain();

      await this.removeToken();
      this.setLoggedIn(false);
      return true;
    } catch (error) {
      return false;
    }
  }

  setLoggedIn(loggedIn) {
    this.setState({
      loggedIn: loggedIn,
    });
  }

  get isLoggedIn() {
    return this.state.access_token ? true : false;
  }

  getUserRoles() {
    return !!this.state.userRoles ? this.state.userRoles : "";
  };

  async getAccessToken() {
    let access_token = await AsyncSessionStorage.getItem(CommonString.LOCAL_STORAGE_ACCESSTOKEN);
    if (!!!this.state.access_token && !!access_token) {
      this.setState({ access_token: access_token });
    }
    return this.state.access_token;
  }

  async removeToken() {
    await AsyncSessionStorage.removeItem(CommonString.LOCAL_STORAGE_ACCESSTOKEN);
    await AsyncSessionStorage.removeItem(CommonString.LOCAL_STORAGE_REFRESHTOKEN);
    await AsyncSessionStorage.removeItem("CLIENT_ID");
    await AsyncSessionStorage.removeItem("REDIRECT_URI");
  }

  async createSessionString(loginUserdetail) {
    let reqBody = {
      uid: loginUserdetail.uid,
      payerId: loginUserdetail.payerId,
      sessionString: CommonUtility.generate20Character(),
    };
    try {
      await this.dm.userRegistration.updateUserCustomDetails(reqBody, true);
      return true;
    } catch (error) {
      return error;
    }
  }

  async isSessionStringValid(validateToken = false) {
    try {
      const { uid, kcId } = await this.dm.rest.getUser();
      let loginUserdetail = await this.dm.kcAPI.tokenIntrospect((!!uid ? uid : kcId), validateToken);
      if (!!loginUserdetail && !!loginUserdetail.tokenIsValid) {
        loginUserdetail.isConcurrentLogin = false;
        return loginUserdetail;
      } else {
        return loginUserdetail;
      }
    } catch (error) {
      return error;
    }
  }

  async issueNewToken() {
    return this.dm.kcAPI.refreshAuthToken();
  }
  
}
